<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="500" >
      <el-form  :model="formInline" class="demo-form-inline">
        <el-form-item label="重发订单">
          <el-input style="width:200px" :disabled="!isCreate" v-model="formInline.fromTypeId" placeholder="重发订单" />
        </el-form-item>
        <el-form-item label="收件人">
          <el-input style="width:200px" :disabled="!isCreate" v-model="formInline.name" placeholder="请填写收件人" />
        </el-form-item>
        <el-form-item label="收件邮箱">
          <el-input style="width:200px" :disabled="!isCreate" v-model="formInline.email" placeholder="请填写收件邮箱" />
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input style="width:200px" v-model="formInline.productName" placeholder="产品名称" />
        </el-form-item>
        <el-form-item label="物流渠道">
          <el-input style="width:200px"  v-model="formInline.trackChannel" placeholder="请输入物流渠道" clearable />
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input style="width:200px" v-model="formInline.trackNumber" placeholder="请输入物流单号" clearable />
        </el-form-item>

        <el-form-item >
          <el-button style="margin: 0 auto" type="primary" @click="onSubmit">{{botton}}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem, ElButton, ElInput, ElMessage} from "element-plus";
import {addResendEmail} from "@/utils/api";
export default {
  name: "reSendEmail",
  components:{
    ElDialog,ElForm,ElFormItem,ElButton,ElInput
  },
  data(){
    return{
      dialogTableVisible:false,
      isCreate:false,
      title:"手动重发",
      botton:"确定重发",
      formInline:{
        sendArgs:{}
      }
    }
  },
  methods:{
    open(data){
      console.log(data)
      this.dialogTableVisible = true
      if(data.fromTypeId){
        this.formInline ={fromTypeId:data.fromTypeId,name:data.name,email:data.email,...data.sendArgs}
        this.isCreate = false
      }else {
        this.formInline = {}
        this.isCreate = true
      }
    },
    onSubmit(){
      if(!this.formInline.fromTypeId){
        ElMessage.warning('请填写重发马帮单号')
        return false
      }
      if(!this.formInline.name){
        ElMessage.warning('请填写收件人')
        return false
      }
      if(!this.formInline.email){
        ElMessage.warning('请填写收件邮箱')
        return false
      }
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(($[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(! re.test(String(this.formInline.email).toLowerCase()) ){
        ElMessage.warning('请填写合法收件邮箱')
        return false
      }
      if(!this.formInline.productName){
        ElMessage.warning('请填写产品名称')
        return false
      }
      if(!this.formInline.trackChannel){
        ElMessage.warning('请输入物流渠道')
        return false
      }
      if(!this.formInline.trackNumber){
        ElMessage.warning('请输入物流单号')
        return false
      }

      addResendEmail({...this.formInline,isCreate:this.isCreate}).then((res)=>{
        console.log(res)
        this.dialogTableVisible = false
        this.$emit('close')
      }).catch(err=>{
        console.log(err)
      })


    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
</style>